import { chain } from "lodash";

import { REQUEST_FIELDS } from "./constants";

import type { Mortgagee } from "../../../mortgagee-search/mortgagee-search";

export const dataFromChanges = changes =>
  chain(REQUEST_FIELDS)
    .map(({ id, mortgageeType, name }) => {
      const mortgagee = changes[mortgageeType];
      const { Clauses } = mortgagee;
      return id === "Mortgagee" && mortgagee[id]
        ? [
            `MortgageeNumber${mortgageeType === "primary" ? 1 : 2}`,
            `${mortgagee[id]}${
              Clauses && Clauses !== "None" ? ` ${Clauses}` : ""
            }`
          ]
        : [name, mortgagee[id] || ""];
    })
    .filter(([, value]) => typeof value === "string" && value !== "UNDEFINED")
    .fromPairs()
    .value();

export const formatAddress = ({
  AddressLine1,
  AddressLine2,
  AddressState,
  AddressCity,
  AddressZip
}: Mortgagee) =>
  [
    AddressLine1,
    AddressLine2,
    AddressCity,
    `${AddressState}${AddressZip ? " " + AddressZip : ""}`
  ]
    .filter(i => i)
    .join(", ");
